<template>
  <div>
    <div class="input-wrap">
			<label>文章标题</label>
			<el-input v-model="info.article_title" placeholder="请输入文章标题" class="input"></el-input>
		</div>
		<div class="input-wrap">
			<label>文章副标题</label>
			<el-input
        type="textarea"
        :rows="4"
        v-model="info.article_subtitle"
        placeholder="请输入文章副标题"
        class="input"
      ></el-input>
		</div>
		<div class="input-wrap">
  		<label>分类</label>
  		<el-select v-model="info.class_uuid" placeholder="请选择" class="input">
		    <el-option
		      v-for="item in article_class"
		      :key="item.id"
		      :label="item.article_class_name"
		      :value="item.id">
		    </el-option>
		  </el-select>
  	</div>
    <div class="input-wrap">
      <label>权重</label>
      <el-input type="number" v-model="info.sort" placeholder="0～99,越大越靠前" class="input"></el-input>
    </div>
	  <div class="input-wrap">
		  <label>定时发布</label>
		  <el-date-picker
				  style="width: 400px"
				  v-model="info.regular_release_time"
				  type="datetime"
				  value-format="yyyy-MM-dd HH:mm:ss"
				  placeholder="选择日期时间">
		  </el-date-picker>
	  </div>
    <div class="input-wrap">
      <label>文章关键字</label>
      <el-input
        v-model="info.keywords"
        placeholder="请输入文章关键字"
        class="input"
      ></el-input>
    </div>
  	<div class="labels-wrap">
  		<div>选择标签</div>
  		<div class="label-list">
  			<div
  			  v-for="(item, index) of article_label "
  			  :key="item.uuid"
  			  :class="{label_item: true, selected: item.isSelected}"
  			  @click="labelClick(item, index)"
  			>{{item.tag_name}}</div>
  		</div>
  	</div>
		<div>
  		<div>封面图</div>
  	  <imageUpload v-model="article_icon" :limit="1"/>
  	</div>
    <div class="input-wrap">
      <label>输入封面图alt</label>
      <el-input v-model="info.alt" placeholder="请输入图片alt" class="input"></el-input>
    </div>
    <div class="quill-wrap">
  		<div>图文详情</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.article_content"/> -->
      <!-- <dankal-editor
        v-model="info.article_content"
        :config="config"
        height="450px"
      /> -->
      <wang-editor ref="editor" id="content" value="#content"></wang-editor>
    </div>
    <!-- <wang-editor></wang-editor> -->
     <div class="btns-wrap">
    	<el-button type="primary" @click="confirmClick">确认</el-button>
    	<el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import Quill from '@/components/quill-editor';
import ImageUpload from '@/components/ImageUpload';
import { addArticle, getArticleDetail, editArticle } from '@/api/article-manage';
import { mapState } from 'vuex';
import DankalEditor from '@/components/editor/dankal-editor';
import Editor from '../../mixins/editor';
import WangEditor from '@/components/WangEditor';

export default {
  mixins: [Editor],
  data() {
    return {
    	info: {
        article_title: '',
        article_subtitle: '',
        class_uuid: '',
        tag_uuid: '', //多个时逗号拼接
        article_icon: '',
        article_content: '',
        sort: '',
        regular_release_time: ''
      },
      article_icon: [],
      selected_tag: [],
      handleType: 'add',
    };
  },
  computed: {
    ...mapState(['article_label', 'article_class'])
  },
  components: {
  	Quill,
    ImageUpload,
    DankalEditor,
    WangEditor
  },
  mounted() {
    //每次进入先把标签选中状态清空
    this.handlleLabel();
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.handleType = 'edit'
      this._getArticleDetail(uuid)
    }
  },
  methods: {
  	labelClick(item, index) {
      item.isSelected = item.isSelected ? !item.isSelected : true;
      //使用set方法 是数据响应更新
      this.$set(this.article_label, index, item)
  	},
  	cancelClick() {
  		this.$router.go(-1);
    },
    async confirmClick() {
      //先置空
      this.selected_tag = [];
      this.article_label.forEach(item => {
        if (item.isSelected) {
          //选择的tag
          this.selected_tag.push(item.id)
        }
      })
      this.info.tag_uuid = this.selected_tag.join(',');
      this.info.article_icon = this.article_icon.join('');
      const {
        article_title,
        article_subtitle,
        class_uuid,
        tag_uuid,
        article_icon,
        // article_content,
        sort,
        keywords,
        alt,
        regular_release_time
      } = this.info;
      const article_content = this.$refs.editor.getContent();
      this.info.article_content = article_content;
      if (!article_title) {
        this.$message('文章标题不能为空')
        return
      }
      if (!article_subtitle) {
        this.$message('文章副标题不能为空')
        return
      }
      if (!class_uuid) {
        this.$message('请选择分类')
        return
      }
      if (!sort) {
     	 this.$message('权重不能为空');
     	 return
      }
      if (+sort < 0 || +sort > 99 || sort%1 !== 0) {
     	 this.$message('权重必须为0～99之间的整数');
     	 return
      }
      if (!keywords) {
     	 this.$message('关键字不能为空');
     	 return
      }
      if (!article_icon){
        this.$message('请上传封面图')
        return
      }
      if (!alt){
        this.$message('请输入图片alt')
        return
      }
      if (!article_content){
        this.$message('图文详情不能为空')
        return
      }
      if (this.handleType === 'add') {
        const { status } = await addArticle(this.info);
        if (status === 200) this.$router.go(-1)
      } else if (this.handleType === 'edit') {
        const { status } = await editArticle(this.info);
        if (status === 200) this.$router.go(-1)
      }
      console.log(this.info, 'info')
    },
    handlleLabel() {
      this.article_label.forEach( item => {
        item.isSelected = false;
      })
    },
    async _getArticleDetail(uuid) {
      const { data, status } = await getArticleDetail(uuid);
      if (status !== 200) return
      this.info = data;
      this.article_icon = [data.article_icon];
      this.selected_tag = data.tag_uuid.indexOf(',') !== -1 ? data.tag_uuid.split(',') : [data.tag_uuid];
      this.article_label.forEach( item => {
        if (this.selected_tag.includes(`${item.id}`)) {
          item.isSelected = true
        } else {
          item.isSelected = false
        }
      })
      this.$refs.editor.setContent(data.article_content);
      console.log(this.selected_tag, this.article_label, data, 'detail data')
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.input-wrap {
	margin-bottom: 20px;
	label {
		display: block;
		margin-bottom: 10px;
	}
	.input {
		width: 400px;
	}
}
.quill-wrap {
	margin-top: 30px;
	margin-bottom: 50px;
}
.btns-wrap {
	display: flex;
	justify-content: center;
}
.label-list {
	display: flex;
	flex-wrap: wrap;
	margin-top: 10px;
	.label_item {
		min-width: 100px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin-right: 20px;
		margin-bottom: 10px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		cursor: pointer;
	}
	.selected {
		background: @color-text;
		color: #fff;
	}
}
.upload_img_wrap {
	display: flex;
	justify-content: space-between;
	margin-right: 100px;
	margin-top: 20px;
}
</style>
